module.exports = __webpack_public_path__ + "static/media/05.9412fa79.jpg";